var React = require('react');

function RecordistFilterIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#025A4D","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M10.75 20.5c5.385 0 9.75-4.365 9.75-9.75S16.135 1 10.75 1 1 5.365 1 10.75s4.365 9.75 9.75 9.75Z","key":0}),React.createElement("path",{"stroke":"#025A4D","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M10.75 10.75a2.249 2.249 0 0 0 2.248-2.25 2.249 2.249 0 1 0-2.248 2.25ZM13.747 13c1.656 0 2.977 1.495 1.809 2.67-1.103 1.108-2.863 1.83-4.806 1.83s-3.703-.722-4.806-1.83C4.776 14.494 6.097 13 7.753 13h5.994Z","key":1})]);
}

RecordistFilterIconInline.defaultProps = {"width":"22","height":"22","fill":"none","viewBox":"0 0 22 22"};

module.exports = RecordistFilterIconInline;

RecordistFilterIconInline.default = RecordistFilterIconInline;
